// Central contact details — update here to change them everywhere.
export const PHONE = '+213 555 97 80 84'
export const WHATSAPP_NUMBER = '213555978084'
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`
